// eslint-disable-next-line @typescript-eslint/no-require-imports, camelcase
const { code_types_obj } = require('@readme/server-shared/shared');

export const type = 'code';

export const languages: Record<string, string> = code_types_obj();
